import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-slider-main-quienes',
  templateUrl: './slider-main-quienes.component.html',
  styleUrls: ['./slider-main-quienes.component.css']
})
export class SliderMainQuienesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
